import React from 'react';
import { MousePointerClick, Crosshair, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

const HOW = {
  scalar: 'Type a formula in the yellow cell.',
  column: 'Write the formula in the first yellow cell and fill it down the whole range.',
  spill: 'Write ONE formula in the yellow cell — the result should spill downwards.',
  cf: 'Select the range, then use Conditional Formatting in the Start toolbar (or right-click).',
  dv: 'Select the range, then use Data → Data Validation.',
};

export const TaskBanner = ({ item, index, onLocate, onNext }) => (
  <div className="shrink-0 border-b border-slate-200 bg-gradient-to-r from-emerald-50 via-white to-white px-5 py-3 flex items-start gap-4"
    data-testid="task-instruction-card">
    <span className="mt-0.5 w-8 h-8 rounded-lg bg-emerald-600 text-white text-sm font-bold flex items-center justify-center shrink-0">{index}</span>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-slate-900 leading-snug" data-testid="task-prompt">{item.prompt}</p>
      <p className="text-xs text-slate-500 mt-1 flex items-center gap-1.5">
        <MousePointerClick className="h-3.5 w-3.5" /> {HOW[item.kind]}
        <span className="ml-1 font-mono text-[11px] text-indigo-700 bg-indigo-50 border border-indigo-100 px-1.5 py-0.5 rounded">{item.sheet}!{item.target}</span>
      </p>
    </div>
    <div className="flex gap-2 shrink-0">
      <Button size="sm" variant="outline" className="h-8 gap-1.5 bg-white" onClick={onLocate} data-testid="locate-task-cell-btn">
        <Crosshair className="h-3.5 w-3.5" /> Go to cell
      </Button>
      <Button size="sm" className="h-8 gap-1 bg-slate-900 hover:bg-slate-800 text-white" onClick={onNext} data-testid="next-item-btn">
        Next <ChevronRight className="h-3.5 w-3.5" />
      </Button>
    </div>
  </div>
);

export default TaskBanner;
